module.exports = __webpack_public_path__ + "img/filters-sliders-icon-17022022.403524f7.svg";